import { useState } from 'react'
import styled from 'styled-components'
import CreationToolStatus from '../../../../types/status'
import { CreationToolUploadSource } from '../../types'
import Buttons from './buttons'
import Icon from './icon'
import Label from './label'
import StatusBar from './status-bar'

const Header = styled.div`
    align-items: center;
    display: flex;
    height: 50px;
    width: 100%;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 0; // fixes truncation issues with flexbox
    position: relative;
    width: 100%;
`

const Wrapper = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    width: 100%;
`

const Hit = styled.div`
    cursor: pointer;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

type Props = {
    className?: string
    source: CreationToolUploadSource
    isBulk?: boolean
    isPreviewing?: boolean
    isDragging?: boolean
    isUploading?: boolean
    setIsPreviewing: (isPreviewing: boolean) => void
}

const CreationUploadItemHeader = ({
    className,
    source,
    isBulk = false,
    isPreviewing = false,
    isUploading = false,
    setIsPreviewing,
}: Props) => {
    const [isHovered, setHovered] = useState<boolean>(false)
    const [isEditing, setIsEditing] = useState(false)
    const { error, status, uploadedId } = source
    return (
        <Header
            {...{
                className,
                onMouseOver: () => setHovered(true),
                onMouseOut: () => setHovered(false),
            }}
        >
            <Icon source={source} showRemoveIcon={isHovered} />
            <Content>
                {isBulk && <Hit onClick={() => setIsPreviewing(!isPreviewing)} />}
                <Wrapper>
                    <Label
                        onEditing={(isEditing) => setIsEditing(isEditing)}
                        source={source}
                        disabled={!!error || !!uploadedId || status !== CreationToolStatus.Idle || isUploading}
                    />
                    <Buttons
                        {...{
                            source,
                            isPreviewing,
                            isHovered,
                            isEditing,
                            onTogglePreview: setIsPreviewing,
                        }}
                    />
                </Wrapper>
                <StatusBar status={status} isError={!!error} />
            </Content>
        </Header>
    )
}

export default CreationUploadItemHeader
